export default __webpack_public_path__ + "static/media/readme-generator.8fc86ce6.png";